var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"color":"error-body"}},[(_vm.showErrors())?_vm._l((_vm.listOfErrors()),function(error,index){return _c('div',{key:index,staticClass:"mandotry-color"},[_vm._v("\n      "+_vm._s(error)+"\n    ")])}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }